import api from "@/lib/api";

/**
 * ZEN-784 (review rounds 3 and 4): add one value to a list kept in the user's
 * preferences ("dismissed_panels", "dismissed_setup_beneficiaries", ...).
 *
 * The server replaces the whole list on every save, so:
 *  - the close shows on screen the moment it is clicked, before any save;
 *  - saves run one after another, each sending the newest list, so two closes
 *    clicked in quick succession never wipe each other out;
 *  - if the saved list has not loaded yet, it is loaded before the first save,
 *    so a close never replaces the list with itself alone;
 *  - the list is re-read from the server only once every save has finished,
 *    so a re-read cannot briefly bring back a close still waiting to be saved.
 */
const KEY = ["user-prefs"];
let queue = Promise.resolve();
let pending = 0;

export function addToPrefsList(qc, field, value) {
  pending += 1;
  qc.cancelQueries({ queryKey: KEY });
  const shown = qc.getQueryData(KEY);
  if (shown && !(shown[field] || []).includes(value)) {
    qc.setQueryData(KEY, { ...shown, [field]: [...(shown[field] || []), value] });
  }
  const step = queue.then(async () => {
    const latest = await qc.ensureQueryData({ queryKey: KEY, queryFn: async () => (await api.get("/user-prefs")).data });
    const current = latest[field] || [];
    const next = current.includes(value) ? current : [...current, value];
    qc.setQueryData(KEY, { ...latest, [field]: next });
    const saved = (await api.put("/user-prefs", { [field]: next })).data;
    // Keep anything clicked while this save was on its way.
    if (saved) qc.setQueryData(KEY, (old) => ({ ...old, ...saved, [field]: [...new Set([...(saved[field] || []), ...((old || {})[field] || [])])] }));
  });
  // A failed save must not stop the next one; the failure still reaches the caller.
  queue = step.catch(() => {});
  return step.finally(() => {
    pending -= 1;
    if (pending === 0) qc.invalidateQueries({ queryKey: KEY });
  });
}
